import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle } from 'lucide-react';

interface BatchDeleteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  batchNumber: string;
  loading?: boolean;
}

export const BatchDeleteModal: React.FC<BatchDeleteModalProps> = ({
  open,
  onClose,
  onConfirm,
  batchNumber,
  loading = false,
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Delete Batch
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-red-50 dark:bg-red-900/20 p-4 rounded-lg border border-red-200 dark:border-red-800">
            <p className="text-sm text-gray-700 dark:text-gray-300">
              Are you sure you want to delete batch <strong>"{batchNumber}"</strong>?
            </p>
            <p className="text-sm text-red-600 dark:text-red-400 mt-2">
              This action cannot be undone. The batch will be permanently removed from the system.
            </p>
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={onConfirm}
              disabled={loading}
              className="bg-red-600 hover:bg-red-700"
            >
              {loading ? 'Deleting...' : 'Delete Batch'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};